import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Loader2, PenLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PostCard, CATEGORY_LABELS, catLabel } from "@/components/blog/BlogFeed";
import { API_URL } from "@/config/api";

export default function BlogPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [posts, setPosts] = useState(null);
  const [total, setTotal] = useState(0);

  const load = async (skip = 0) => {
    const q = new URLSearchParams({ limit: 20, skip });
    if (category) q.set("category", category);
    const d = await fetch(`${API_URL}/api/blog/posts?${q}`).then((r) => r.json());
    setPosts((prev) => (skip && prev ? [...prev, ...d.posts] : d.posts));
    setTotal(d.total);
  };
  useEffect(() => { setPosts(null); load(); }, [category]);

  return (
    <div className="space-y-4 px-1 sm:px-0 pb-8" data-testid="blog-page">
      <div className="flex items-center justify-between">
        <Button variant="ghost" size="sm" onClick={() => navigate("/lobby")}><ArrowLeft className="h-4 w-4 mr-2" />{t("common.back")}</Button>
        <Button size="sm" onClick={() => navigate("/blog/new")} data-testid="blog-new-btn"><PenLine className="h-4 w-4 mr-2" />{t("blog.write")}</Button>
      </div>
      <h1 className="text-2xl sm:text-3xl font-black tracking-tight">{t("blog.feedTitle")}</h1>
      <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: "none" }}>
        {["", ...Object.keys(CATEGORY_LABELS)].map((c) => (
          <button key={c} onClick={() => setParams(c ? { category: c } : {})} data-testid={`blog-cat-${c || "all"}`}
            className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold border transition-colors ${category === c ? "bg-primary text-primary-foreground border-primary" : "border-border/60 text-muted-foreground hover:text-foreground"}`}>
            {c ? catLabel(c, i18n.language) : t("blog.allCategories")}
          </button>
        ))}
      </div>
      {posts === null ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
      ) : posts.length === 0 ? (
        <p className="text-center text-muted-foreground py-16">{t("blog.empty")}</p>
      ) : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {posts.map((p) => <PostCard key={p.id} post={p} lang={i18n.language} />)}
          </div>
          {posts.length < total && (
            <Button variant="outline" className="w-full" onClick={() => load(posts.length)}>{t("blog.loadMore")}</Button>
          )}
        </>
      )}
    </div>
  );
}
